import React, { useEffect } from 'react';
import { TypographyStyledBlack } from '../homescreen/style';
import { ArcContainer } from '../../shared/components/arcContainer';
import CompareFluidIcon from '../../assets/icons/compareFluidIcon.svg';
import CompareSelectedProductsIcon from '../../assets/icons/compareSelectedProductsIcon.svg';
import { BoxStyled } from '../patientInformation/style';
import {
  TypographyH4,
  TypographyH4Bold
} from '../estimatingRequirements/paedFluid/style';
import { Box } from '@mui/material';
import { ProductSelector } from './productSelector';
import { DoubleTextBlueCard } from '../../shared/components/doubleTextBlueCard';
import { useAppSelector } from '../../store/hooks';
import { metaDataSelector } from '../../store/globalSelectors';
import { compareProductAccordionSections } from '../../shared/shared.constants';
import { NavigationButtons } from '../../shared/components/navigationButtons';
import { formatCategoryName } from '../../shared/utils/utilFunctions';
import { setCompareData } from '../../store/slices/metaDataSlice';
import { useDispatch } from 'react-redux';

export const Compare = () => {
  const dispatch = useDispatch();
  const { compare } = useAppSelector(metaDataSelector);
  const { checkedItems, selectedProducts } = compare;

  useEffect(() => {
    // Get selected products with their category
    const selectedProducts = compareProductAccordionSections.flatMap(
      (section) =>
        section.products
          .filter((product) => checkedItems[product.id])
          .map((product) => ({
            ...product,
            category: formatCategoryName(section.title)
          }))
    );

    dispatch(
      setCompareData({
        ...compare,
        selectedProducts: selectedProducts
      })
    );
  }, [checkedItems]);

  return (
    <BoxStyled>
      <TypographyStyledBlack sx={{ margin: '0.625rem 0' }}>
        PRODUCTS
      </TypographyStyledBlack>

      <ArcContainer icon={CompareFluidIcon} customizedHeight="auto">
        <TypographyH4Bold sx={{ textAlign: 'center' }} className="pt-16">
          SELECT PRODUCTS
        </TypographyH4Bold>
        <TypographyH4 sx={{ textAlign: 'center' }}>
          Choose a maximum of 2 products
        </TypographyH4>
        <ProductSelector />
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%'
          }}
        >
          <DoubleTextBlueCard
            heading1="SELECTED PRODUCTS"
            miniHeading1={
              selectedProducts.length >= 1
                ? selectedProducts[0].name
                : 'No products selected yet'
            }
            miniHeading2={
              selectedProducts.length === 2 ? selectedProducts[1].name : ''
            }
            isCompare={true}
            label1={
              selectedProducts.length >= 1
                ? `${selectedProducts[0].category} - ${selectedProducts[0].volume}`
                : ''
            }
            unit1={''}
            label2={
              selectedProducts.length === 2
                ? `${selectedProducts[1].category} - ${selectedProducts[1].volume}`
                : ''
            }
            unit2={''}
            icon={CompareSelectedProductsIcon}
            mb="3.125rem"
          />
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%'
          }}
        >
          {' '}
          <NavigationButtons
            nextDisabled={selectedProducts.length < 2 ? true : false}
            nextRoute={'/compare/inputs'}
            nextVisible={true}
          />
        </Box>
      </ArcContainer>
    </BoxStyled>
  );
};
